import React from 'react';
import { AppBar, Toolbar, Button, Box, Typography, Container, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useNavigate, useLocation } from 'react-router-dom';
import siteText from '../content/siteText.json';

const Navigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { practice, navigation, contact } = siteText;

    const items = [
        { label: navigation.home, route: '/' },
        { label: navigation.services, route: '/services' },
        { label: navigation.faq, route: '/faqs' },
        { label: navigation.about, route: '/about' },
        { label: navigation.contact, route: '/contact' }
    ];

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                backgroundColor: '#cc6f5f',
                borderBottom: '1px solid rgba(0, 71, 110, 0.10)',
                boxShadow: '0 8px 24px rgba(0, 71, 110, 0.08)'
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    width: 'min(92vw, 1600px)',
                    mx: 'auto'
                }}
            >
                <Toolbar
                    sx={{
                        minHeight: { xs: 108, md: 128 },
                        px: '0 !important',
                        py: { xs: 1.25, md: 1.75 }
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                            gap: 2,
                            flexWrap: 'wrap'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2,
                                cursor: 'pointer'
                            }}
                            onClick={() => navigate('/')}
                        >
                            <Box
                                component="img"
                                src="/img/otglogo_bloom.webp"
                                alt="On The Go Speech logo"
                                sx={{
                                    width: { xs: 64, md: 78 },
                                    height: { xs: 64, md: 78 },
                                    objectFit: 'contain',
                                    display: 'block',
                                    flexShrink: 0
                                }}
                            />

                            <Box>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        color: '#faecf4',
                                        fontWeight: 700,
                                        letterSpacing: 0.2,
                                        lineHeight: 1.02,
                                        fontSize: { xs: '1.8rem', md: '2.35rem' }
                                    }}
                                >
                                    {practice.name}
                                </Typography>

                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: 'rgba(250, 236, 244, 0.88)',
                                        mt: 0.5,
                                        fontWeight: 500,
                                        fontSize: { xs: '0.95rem', md: '1rem' }
                                    }}
                                >
                                    {practice.subtitle}
                                </Typography>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                gap: 1,
                                flexWrap: 'wrap',
                                alignItems: 'center'
                            }}
                        >
                            {items.map((item) => {
                                const selected = location.pathname === item.route;

                                return (
                                    <Button
                                        key={item.route}
                                        onClick={() => navigate(item.route)}
                                        sx={{
                                            color: selected ? '#ffffff' : '#faecf4',
                                            backgroundColor: selected ? '#ff751f' : 'transparent',
                                            borderRadius: 999,
                                            px: 2.5,
                                            py: 1.15,
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            border: selected
                                                ? '1px solid rgba(255,255,255,0.10)'
                                                : '1px solid rgba(250,236,244,0.26)',
                                            '&:hover': {
                                                backgroundColor: selected
                                                    ? '#ff751f'
                                                    : 'rgba(250, 236, 244, 0.10)'
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </Button>
                                );
                            })}

                            <Link
                                href={contact.instagramUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Visit Instagram"
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#faecf4',
                                    ml: 0.5,
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    border: '1px solid rgba(250,236,244,0.26)',
                                    backgroundColor: 'transparent',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: 'rgba(250, 236, 244, 0.10)',
                                        color: '#ffffff'
                                    }
                                }}
                            >
                                <InstagramIcon sx={{ fontSize: 22 }} />
                            </Link>

                            <Link
                                href={contact.facebookUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Visit Facebook"
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#faecf4',
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    border: '1px solid rgba(250,236,244,0.26)',
                                    backgroundColor: 'transparent',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: 'rgba(250, 236, 244, 0.10)',
                                        color: '#ffffff'
                                    }
                                }}
                            >
                                <FacebookIcon sx={{ fontSize: 22 }} />
                            </Link>
                        </Box>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navigation;